
<template>
    <rkm-form ref="Form">
        <box-fechamento
            v-if="loaded"
            :data="{ initials, form, model, additionals, dataAtual }"
            @handleAtualizaPaciente="handleAtualizaPaciente"
        />
    </rkm-form>
</template>

<script>
import BoxFechamento from '@/components/exame-imagem/fechamento/components/Form'

import { mapActions } from 'vuex'
import { repository, error, object, data, stringCase } from '@/mixins'

// Enuns.
import statusFechamento from '@/enums/exame-imagem/fechamento/status'

export default {
    components: { BoxFechamento },
    created() {

        this.repositories = {
            fechamento: this.getConectaSusRepository('exameImagem.fechamento')
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        initials: {
            model: {}
        },
        form: {},
        model: {},
        additionals: {},
        idPacienteNovo: null,
        dataAtual: null,
        enums:{statusFechamento},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.fechamento.list()
                .then(({ data }) => {

                    data.model.periodo.start = this.getDateObject(data.model.periodo.start)
                    data.model.periodo.end = this.getDateObject(data.model.periodo.end)

                    this.initials.model = Object.freeze(this.clone(data.model))

                    this.form = data.form
                    this.model = data.model

                    this.additionals = data.additionals
                    this.dataAtual = data.dataAtual;

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save(){

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    let agendamentosComProtocoloFechamento = this.model.agendamentos.filter(agendamento =>
                        agendamento.statusId == this.enums.statusFechamento.REALIZADO
                        && agendamento.numero
                        && agendamento.numero !== agendamento.protocoloFechamento
                        && !!agendamento.controlaProtocoloFechamento
                    )

                    if (agendamentosComProtocoloFechamento.length > 0) {
                        this.showValidationNotification('Existe(m) protocolo(s) de fechamento não informado(s) e/ou inválido(s).')
                        return
                    }

                    this.setLoading()

                    this.repositories.fechamento.store(this.prepareData())
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)

                            this.loadList()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const model = this.clone(this.model)

            const filterNotSave = model.agendamentosNotSave.filter(
                item => item.statusId !== this.enums.statusFechamento.AGENDADO
            );

            const agendamentoExameId = filterNotSave.map(item => item.agendamentoExameId)

            const agendamentosFilter = model.agendamentos.filter(
                item => agendamentoExameId.includes(item.agendamentoExameId)
            )

            const newModel = {
                agendamentos: agendamentosFilter,
                agendamentosNotSave:filterNotSave
            }

            return this.camelObjectKeysToSnakeRecursive(newModel)
                        
        },
        loadList(){

            this.setLoading()

            this.repositories.fechamento.list()
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model
                    this.additionals = data.additionals
                })
                .finally(() => this.unsetLoading())
        },
        handleAtualizaPaciente(value){

            this.idPacienteNovo = value

            this.$emit('handleAtualizaLancamento', this.idPacienteNovo)
        }
    },
    mixins: [repository, error, object, data, stringCase]
}
</script>